/**
 * Created by mauget on 2/3/16.
 */

// ControlSmallHeadingFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import SmallHeadingControlView  from 'common-visuals/SmallHeadingControlView.js';


//=============================================================================
//
// Creates a Large Heading control view, given a factoryService parameter key
// and a layout postion. The factory key defines the  initial rectangle of the
// control via a width and height from the factory parameter.
//
// -Lou Mauget, Feburary 3, 2016
//
//=============================================================================
class ControlSmallHeadingFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;
        attributes.styleColorText = '~smallHeadingTextColor';
        attributes.fontFamily = '~smallHeadingFont';
        attributes.fontSize = '~smallHeadingFont';
        attributes.textWeight = '~smallHeadingFont';
        attributes.textStyle = '~smallHeadingFont';
        attributes.inlineEditable = true;
        attributes.maxChars = '';
        attributes.resizePadding = 2;
        attributes.isHtml = false;
        attributes.text = 'Small Heading';
		attributes.minWidth = 10;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

        //adding silent(accessibility) to attributes.
        attributes.silent = false;

        const view = new SmallHeadingControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlSmallHeadingFactory = new ControlSmallHeadingFactory();

export default controlSmallHeadingFactory;

